import React, { useState } from "react";
import visionLogo from "../../images/vision-logo.png";
import backImg from "../../images/back-img.png";
import { Link, useNavigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { LOGINPOSTREQUEST } from "../helpers/ServiceRequest";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [pwError, setPwError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  let navigate = useNavigate();
  const [type, setType] = useState('password');
  const [icon, setIcon] = useState('bi bi-eye-slash');
  const { signin } = useAuth();

  const login = async (e) => {
    e.preventDefault();
    setDisabled(true);
    let loginURL = process.env.REACT_APP_API_URL + "/login";
    if (email == "" && password == "") {
      setEmailError(true);
      setPwError(true);
      return false;
    }
    if (email && password) {
      let payload = { Email: email, Password: password };

      let response = await LOGINPOSTREQUEST(loginURL, payload);
      if (response?.data) {
        let data = response.data;
        const userObj = {
          jwtToken: data.jwtToken,
          userName: data.UserName,
          firstName: data.FirstName,
          lastName: data.LastName,
          role: data.Role,
          email: data.Email,
          isAuthenticated: "true",
          userId: data.UserID,
        };
        signin(userObj, () => {
          navigate("/veg-art");
        });
        setDisabled(false);
      } else if(response?.error) {
        let message = response.error?.message ? response.error.message : "Email or password is incorrect !!!"
            setTimeout(() => {
              setDisabled(false);
            }, 500);
            setErrorMessage(message);
      }
    } else if (email == "") {
      setEmailError(true);
    } else if (password == "") {
      setPwError(true);
    }
  };
  const handleToggle = () => {
    if (type === 'password') {
      setIcon('bi bi-eye');
      setType('text')
    } else {
      setIcon('bi bi-eye-slash')
      setType('password')
    }
  }

  return (
    <section className="login" style={{ backgroundImage: `url(${backImg})` }}>
      <div className="login-container h-100">
        <div className="row justify-content-lg-end justify-content-center align-items-center h-100">
          <div className="width-xl-28 width-lg-55 width-md-80">
            <div className="card p-4 rounded-4">
              <div className="card-header bg-white border-0 text-center py-3">
                <img src={visionLogo} alt="" />
              </div>
              <div className="card-body">
                <h5 className="card-title text-center title-bold fs-32 mb-1">
                  Welcome back!
                </h5>
                <p className="text-center fs-15 text-lite">
                  Please enter details to login
                </p>
                <div className="spacer-2"></div>
                <form onSubmit={login}>
                  <div className="mb-3">
                    <label
                      htmlFor="email"
                      className="form-label fw-medium input-bold"
                    >
                      Email*
                    </label>
                    <input
                      type="email"
                      className={
                        "form-control input-lg " +
                        (emailError ? " is-invalid" : "")
                      }
                      id="email"
                      placeholder="Email"
                      onChange={(e) => {
                        setEmailError(false);
                        setEmail(e.target.value);
                        if (e.target.value && password) {
                          setDisabled(false);
                        } else {
                          setDisabled(true);
                        }
                      }}
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label fw-medium">
                      Password*
                    </label>
                    <div className="input-group">
                      <input
                        type={type}
                        id="password"
                        className={
                          "form-control input-lg  " +
                          (pwError ? " is-invalid" : "border-end-0")
                        }
                        placeholder="Password"
                        onChange={(e) => {
                          setPwError(false);
                          setPassword(e.target.value);
                          if (e.target.value && email) {
                            setDisabled(false);
                          } else {
                            setDisabled(true);
                          }
                        }}
                      />
                      <div
                        type="button"
                        id="togglePassword"
                        className="btn btn-outline-light hover-none border-start-0 d-flex align-items-center"
                        onClick={handleToggle}
                      >
                        <i className={icon}></i>
                      </div>
                    </div>
                    {errorMessage && (
                      <div className="text-danger text-center">
                        {" "}
                        {errorMessage}{" "}
                      </div>
                    )}
                  </div>
                  <div className="mb-3 form-check d-inline-block">
                    <input
                      type="checkbox"
                      className="form-check-input "
                      id="remember"
                    />
                    <label
                      className="form-check-label fs-15"
                      htmlFor="remember"
                    >
                      Remember me
                    </label>
                  </div>
                  <Link
                    to="/forgot-password"
                    className="float-end text-decoration-none fs-15 text-link"
                  >
                    Forgot Password?
                  </Link>
                  <div className="spacer-2"></div>
                  <div className="d-grid">
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg fw-medium text-white d-flex align-items-center justify-content-center"
                    >
                      Login
                    </button>
                  </div>
                </form>
              </div>
              <div className="card-footer bg-white border-0 py-3">
                <p className="fs-13 text-center mb-0">
                  Copyright@2023. Vision Produce.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default Login;
